import { Link as RouterLink } from 'react-router-dom';
import { Box, Button, Container, useTheme, useMediaQuery, makeStyles, Theme } from '@material-ui/core';
import Page from '../../atoms/layout/page';
import {useEffect, useState} from "react";
import UtilService from "../../../helper/service";
import roles from "../../../helper/roles";

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    backgroundColor: theme.palette.background.paper,
    minHeight: '100%',
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(3),
    paddingTop: 80,
    paddingBottom: 80
  },
  image: {
    maxWidth: '100%',
    width: 560,
    maxHeight: 300,
    height: 'auto'
  },
  title: {
    fontSize: 64,
    fontFamily: 'Spartan-bold',
    color: '#212D40',
    textAlign: 'center'
  },
  subTitle: {
    fontSize: 20,
    fontFamily: 'roboto-bold',
    color: '#606B76',
    textAlign: 'center'
  },
  button: {
    width: 130,
    height: 37,
    borderRadius: 6,
    backgroundColor: '#0179EE',
    textTransform: 'none',
    color: '#FFFFFF',
    fontSize: 14,
    fontFamily: 'roboto-regular',
    '&:hover': {
      backgroundColor: '#0f9fef'
    }
  }
}));

interface IProps {
  loginUser: any
}

function NotFound(props: IProps) {
  const { loginUser } = props;
  const classes = useStyles();
  const theme = useTheme();
  const mobileDevice = useMediaQuery(theme.breakpoints.down('sm'));
  const loginUserData = localStorage.getItem("user_data") ? JSON.parse(localStorage.getItem("user_data") || "{}") : {};
  const [redirectToHome, setRedirectToHome] = useState('');

  useEffect(() => {
    let _redirectToHome = '';
    if (loginUser) {
      _redirectToHome = '/user/profile';
      if (!!loginUserData) {
        if (UtilService.checkTrialAccess(loginUserData, roles['trial']['profile'])) {
          _redirectToHome = '/subscriber/user/profile';
        }
      }
    } else {
      _redirectToHome = '/user/login';
    }
    setRedirectToHome(_redirectToHome);
  }, [loginUser, loginUserData]);

  useEffect(() => {
    if (loginUserData.role_access && loginUserData.role_access.length > 0) {
      const creator_dashboard = loginUserData.role_access.filter((val: any) => val.access_name === "creator_dashboard");
      let url = '';
      if (creator_dashboard.length > 0 && creator_dashboard[0].access_value) {
        url = "/creator/dashboard"
      } else if (UtilService.checkTrialAccess(loginUserData, roles['trial']['dashboard'])) {
        url = "/subscriber/creator/dashboard"
      } else {
        const participant_dashboard = loginUserData.role_access.filter((val:any) => val.access_name === "participant_dashboard");
        if(participant_dashboard.length > 0 && participant_dashboard[0].access_value){
          url = "/participant/dashboard"
        }
      }
      setRedirectToHome(url);
    }
  }, [loginUserData]);

  return (
    <Page
      className={classes.root}
      title="404: Not found"
    >
      <Container maxWidth="lg">
        {mobileDevice ? (
          <div className='profile-title' style={{textAlign: "center"}} color='textPrimary'>
            Oops! Brain Freeze!!
          </div>
        ) : (
          <div className={classes.title}>
            Oops! Brain Freeze!!
          </div>
        )}
        <Box
          mt={4}
          display="flex"
          justifyContent="center"
        >
          <div className={classes.subTitle}>
            <div>
              Page Not Found :(
            </div>
            <div style={{ marginTop: 8 }}>
              Check that you typed in the URL correctly, or just click the button below to go back home.
            </div>
          </div>
        </Box>
        <Box
          mt={4}
          display="flex"
          justifyContent="center"
        >
          <Button
            type="button"
            component={RouterLink}
            to={redirectToHome}
            className={classes.button}
          >
            Go Home
          </Button>
        </Box>
        <Box
          mt={6}
          display="flex"
          justifyContent="center"
        >
          <img
            alt="Under development"
            className={classes.image}
            src="/static/404.svg"
          />
        </Box>
      </Container>
    </Page>
  );
}

export default NotFound;